import { ListingColDefs } from '@/list/column-defs/listing-col-defs';
import { fileNames } from '@/list/list-constants';

function getDownloadFileNameReportTypeComponent(regType, configType) {
  const regTypeBasedFileName = fileNames[regType];

  if (regTypeBasedFileName) return regTypeBasedFileName;

  const configTypeBasedFileName = fileNames[configType];

  if (!configTypeBasedFileName) return 'report';

  return `${regType}-${configTypeBasedFileName}`;
}

export function downloadExcel(
  activeNav,
  configType,
  gridApi,
  colDefs,
  city,
  columnApi
) {
  const downloadFileNameReportTypeComponent =
    getDownloadFileNameReportTypeComponent(activeNav, configType);

  const params = {
    autoConvertFormulas: true,
    fileName: `${city}-${downloadFileNameReportTypeComponent}.xlsx`,
    fontSize: 12,
    sheetName: downloadFileNameReportTypeComponent,
    /**
     * Certain column values need to be reformatted from a raw string
     * We handle this with a switch case for each of the special columns
     * Documentation: https://www.ag-grid.com/react-grid/excel-export-api/#excelexportparams
     */
    processCellCallback: (param) => {
      const { value, column, node } = param;
      const colDef = column.getColDef();

      switch (column.getId()) {
        case colDefs.pdfUrlColumn.colId:
          return value ? `=HYPERLINK("${value}", "PDF")` : value;
        case colDefs.listingUrlColumn.colId:
          return value?.live
            ? `=HYPERLINK("${value?.listingUrl}", "${value?.platform}")`
            : '';
        case colDefs.addressColumn.colId:
          return node?.data?.address;
        case colDefs.licenseStatusColumn?.colId:
          // Add other columns whose valueFormatter should be used in Excel

          /**
           * "useValueFormatterForExport" is explicitly tested against "false", since we're providing
           * a custom callback for "processCellCallback" to be used in "exportDataAsExcel" to handle
           * filling in the values per data cell.
           *
           * Without having this check, the resulting spreadsheet will fill the cells with data
           * that have been processed by the "valueFormatter" per column definition.
           */
          const provideUnformattedValue =
            !colDef.valueFormatter ||
            colDef.useValueFormatterForExport === false;
          if (provideUnformattedValue) return value;

          return colDef.valueFormatter({
            ...param,
            data: node.data,
            node,
            colDef,
          });
        default:
          return value;
      }
    },
  };
  const hiddenCalendarColumns = [];
  columnApi.getAllDisplayedColumns().forEach((item) => {
    if (item.colId.includes(ListingColDefs.calendarColId) && item.visible) {
      hiddenCalendarColumns.push(item.colId);
    }
  });

  // pre-download changes
  hiddenCalendarColumns.forEach((id) => {
    columnApi.setColumnVisible(id, false);
  });
  columnApi.removeRowGroupColumn(colDefs.groupByAddressColumn.colId);

  gridApi.exportDataAsExcel(params);

  // restore original grid after
  columnApi.addRowGroupColumn(colDefs.groupByAddressColumn.colId);
  hiddenCalendarColumns.forEach((id) => {
    columnApi.setColumnVisible(id, true);
  });
}
